import { Controller } from '@hotwired/stimulus'

// Compose preview only: mirrors message + retryable UI into
// Email::NotifySubscribersViewComponent (not loaded for real mail HTML).
export default class extends Controller {
  static targets = ['bodyInput', 'bodyMirror', 'retryableInput', 'takeAction', 'noAction', 'stepPrefix']

  connect () {
    this.syncAll()
    requestAnimationFrame(() => this.syncAll())
  }

  syncAll () {
    this.syncBody()
    this.syncRetryable()
  }

  syncBody () {
    if (!this.hasBodyMirrorTarget || !this.hasBodyInputTarget) return
    this.bodyMirrorTarget.textContent = this.bodyInputTarget.value
  }

  syncRetryable () {
    const retryable =
      this.hasRetryableInputTarget && this.retryableInputTarget.checked
    if (this.hasStepPrefixTarget) {
      this.stepPrefixTarget.classList.toggle('hidden', !retryable)
    }
    if (!this.hasTakeActionTarget || !this.hasNoActionTarget) return
    this.takeActionTarget.classList.toggle('hidden', !retryable)
    this.noActionTarget.classList.toggle('hidden', retryable)
  }
}
